import React, { memo } from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import '../../Static/Master/firmtable.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import PreviewIcon from '@mui/icons-material/Preview';
import { deleteAdminSale } from '../../Store/PHPSlice/stockApi';


const TableBody4 = ({
    serialNumber,
    id,
    itemId,
    itemNm,
    size,
    adsid,
    billNo,
    qty,
    bqty,
    sqty,
    amt,
    srate,
    prate,
    schlId,
    schlNm,
    schlcd,
    selected,
    fdt,
    tdt,
    sts,
    handleClick,
}) => {
    const dispatch = useDispatch();
    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open
        window.open(`/admin-sale-edit/${id}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };
    const handleDeleteClick = () => {
        // Show confirmation dialog
        const isConfirmed = window.confirm("Are you sure you want to delete this Item?");

        // If user confirms, proceed with deletion
        if (isConfirmed) {
            // dispatch(deleteAdminSale(id))
            //     .then(() => {
            //         // Reload the page to show updated results
            //         toast("Sale Invoice Deleted Sucessfully");
            //         window.location.reload();
            //     })
            //     .catch((error) => {
            //         // Handle any errors that occur during the deletion process
            //         console.error("Error deleting Item:", error);
            //         toast.error("Failed to delete Item");
            //     });
        }
    };


    const handleViewClick = () => {
        const pdata = [itemId, schlId, fdt, tdt];
        window.open(`/admin-item-report-view/${pdata}`, '_blank', 'width=1000,height=700,scrollbars=yes,resizable=yes');
    };
    // if (sqty <= 0) return null;

    const handleUserSaleClick = () => {
        const pdata = [itemId,schlId, adsid ];
        if (sqty > 0) {
            window.open(`/user-item-report-view/${pdata}`, '_blank', 'width=1000,height=700,scrollbars=yes,resizable=yes');
        }
    };

    // console.log(adsid)
    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {serialNumber}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {billNo}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {schlNm} - <span style={{ color: 'blue' }}>{schlcd}</span>
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {itemNm}
                </TableCell>

                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {size}
                </TableCell> */}

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {qty}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className={`${sqty > 0 ? 'cursor-pointer' : ''}`} onClick={handleUserSaleClick}>
                    {sqty}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {bqty}
                </TableCell>

                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {srate}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {prate}
                </TableCell> */}

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <PreviewIcon onClick={handleViewClick} className='cursor-pointer' />
                </TableCell>

                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <EditIcon className="cursor-pointer" onClick={handleEditClick} />
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <DeleteIcon className={`cursor-pointer ${sts === '1' ? 'disabled-icon' : ''}`} onClick={handleDeleteClick} />
                </TableCell> */}


            </TableRow>
        </>
    );
};

export default TableBody4;
